import store from '@/app/store/index'

const predefinedColors = [
  "#FFB340",
  "#7D7AFF",
  "#30DB5B",
  "#FF6482",
  "#DA8FFF",
  "#51af71",
  "#e8757f",
  "#fff367",
  "#650e81",
  "#a56800",
  "#740047",
  "#e47508",
  "#4e6b06",
  "#363026",
  "#7d7d7d",
  "#34004a",
  "#8d8100",
  "#dd0053",
  "#8fd324",
  "#4e6b06",
];

let estrategiaAtivosColors = [];
let carregandoEstrategiaAtivosColors = false;

const coresIndexadores = [
  { nome: "CDI", cor: "#D30F45" },
  { nome: "DOLAR COMERCIAL", cor: "#884A97" },
  { nome: "IBOVESPA", cor: "#FF8946" },
  { nome: "IPCA", cor: "#00A167" },
  { nome: "IGPM", cor: "#FF7452" },
  { nome: "POUPANÇA", cor: "#5755BE" },
  { nome: "CARTEIRA", cor: "#26BD7E" }
];

// Eu nem tentei entender o que isso faz
// https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
// Version 4.0
const pSBC = function(p, c0, c1, l) {
  let r,
    g,
    b,
    P,
    f,
    t,
    h,
    i = parseInt,
    m = Math.round,
    a = typeof c1 == "string";
  if (
    typeof p != "number" ||
    p < -1 ||
    p > 1 ||
    typeof c0 != "string" ||
    (c0[0] != "r" && c0[0] != "#") ||
    (c1 && !a)
  )
    return null;
  var pSBCr = d => {
    let n = d.length,
      x = {};
    if (n > 9) {
      ([r, g, b, a] = d = d.split(",")), (n = d.length);
      if (n < 3 || n > 4) return null;
      (x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4))),
        (x.g = i(g)),
        (x.b = i(b)),
        (x.a = a ? parseFloat(a) : -1);
    } else {
      if (n == 8 || n == 6 || n < 4) return null;
      if (n < 6)
        d =
          "#" +
          d[1] +
          d[1] +
          d[2] +
          d[2] +
          d[3] +
          d[3] +
          (n > 4 ? d[4] + d[4] : "");
      d = i(d.slice(1), 16);
      if (n == 9 || n == 5)
        (x.r = (d >> 24) & 255),
          (x.g = (d >> 16) & 255),
          (x.b = (d >> 8) & 255),
          (x.a = m((d & 255) / 0.255) / 1000);
      else (x.r = d >> 16), (x.g = (d >> 8) & 255), (x.b = d & 255), (x.a = -1);
    }
    return x;
  };
  (h = c0.length > 9),
    (h = a ? (c1.length > 9 ? true : c1 == "c" ? !h : false) : h),
    (f = pSBCr(c0)),
    (P = p < 0),
    (t =
      c1 && c1 != "c"
        ? pSBCr(c1)
        : P
        ? { r: 0, g: 0, b: 0, a: -1 }
        : { r: 255, g: 255, b: 255, a: -1 }),
    (p = P ? p * -1 : p),
    (P = 1 - p);
  if (!f || !t) return null;
  if (l)
    (r = m(P * f.r + p * t.r)),
      (g = m(P * f.g + p * t.g)),
      (b = m(P * f.b + p * t.b));
  else
    (r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5)),
      (g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5)),
      (b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5));
  (a = f.a),
    (t = t.a),
    (f = a >= 0 || t >= 0),
    (a = f ? (a < 0 ? t : t < 0 ? a : a * P + t * p) : 0);
  if (h)
    return (
      "rgb" +
      (f ? "a(" : "(") +
      r +
      "," +
      g +
      "," +
      b +
      (f ? "," + m(a * 1000) / 1000 : "") +
      ")"
    );
  else
    return (
      "#" +
      (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0))
        .toString(16)
        .slice(1, f ? undefined : -2)
    );
};

const ColorsService = {
  getRandomColour(seed) {
    if (typeof seed !== "undefined") {
      if (isNaN(seed)) {
        let index = 0;
        let avgAsciiSeed = 0;

        for (var i = 0; i < seed.length; i++) {
          avgAsciiSeed += seed.charCodeAt(i);
        }

        avgAsciiSeed = avgAsciiSeed / seed.length;

        for (var j = 0; j < avgAsciiSeed; j++) {
          index++;

          if (index > predefinedColors.length) {
            index = 0;
          }
        }

        return predefinedColors[index];
      } else if (seed <= predefinedColors.length) {
        return predefinedColors[seed];
      }
    }

    var rgn = Math.floor(Math.random() * predefinedColors.length) - 1;
    return predefinedColors[rgn];
  },

  getIndexadorColor(nomeIndexador) {
    var corIndexador = null;

    coresIndexadores.forEach(cor => {
      if (cor.nome === nomeIndexador.toUpperCase()) {
        corIndexador = cor.cor;
      }
    });

    return corIndexador === null || corIndexador === undefined
      ? this.getRandomColour(nomeIndexador)
      : corIndexador;
  },

  getLigherVersion(color) {
    return pSBC(0.2, color);
  },

  getDarkerVersion(color) {
    return pSBC(-0.5, color);
  },

  getFixedColors(qtd, skip) {
    let colors = [];

    if (skip && !isNaN(skip)) {
      for (let i = skip; i < qtd + skip; i++) {
        colors.push(predefinedColors[i]);
      }
    } else {
      for (let i = 0; i < qtd; i++) {
        colors.push(predefinedColors[i]);
      }
    }

    return colors;
  },

  getRandomColors(qtd) {
    let colors = [];

    while (colors.length != qtd) {
      let color = predefinedColors[Math.floor(Math.random() * predefinedColors.length)];
      if (colors.indexOf(color) === -1) {
        colors.push(color);
      }
    }

    return colors;
  },
//   async carregarEstrategiaColors(){
//     if (!carregandoEstrategiaAtivosColors) {
//       carregandoEstrategiaAtivosColors = true;
//       let result = await AtivoService.listarEstrategiasAtivo();

//       estrategiaAtivosColors = [];
//       result.itens.forEach((item) => {
//         estrategiaAtivosColors.push({ key: item.value, value: "#" + item.codigoHexaCor });
//       });      
//       let usuario = store.getters.usuario;
//       usuario.estrategiaColors = estrategiaAtivosColors;
//       store.commit("setUsuario", usuario);
//       carregandoEstrategiaAtivosColors = false;
//     }
//   },
//   getEstrategiaColor(nome) {
//     estrategiaAtivosColors = store.getters.usuario.estrategiaColors ? store.getters.usuario.estrategiaColors : estrategiaAtivosColors;
//     let estrategia = estrategiaAtivosColors.filter(cor => cor.key === nome);
//     if (estrategia.length > 0) {
//       return estrategia[0].value;
//     } else {
//       return this.getRandomColour();
//     }
//   }
};

export default ColorsService;
